module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_16.ce473770.png";